import React, { useState, useEffect } from 'react';
import SimpleBar from 'simplebar-react';
import { AlignLeft, Bell, Calendar, CheckSquare, Clock, CreditCard, Inbox, Plus, Settings, Tag } from 'react-feather';
import { Button, Container, Dropdown, Nav, Navbar } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
//redux
import { connect } from 'react-redux';
import { toggleCollapsedNav } from '../../redux/action/Theme';

// import CustomInput from './CustomInput';

import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { useEntraLoginRedirect } from '../../utils/useEntraLoginRedirect';


//Images
import avatar2 from '../../assets/img/avatar2.jpg';
import avatar3 from '../../assets/img/avatar3.jpg';
import avatar10 from '../../assets/img/avatar10.jpg';
import avatar12 from '../../assets/img/avatar12.jpg';

import BrandSm from '../../assets/img/logo-light.png';
import Brand from '../../assets/img/Jampack.svg';

import NavSearch from './NavSearch';
import CompactMenu from './CompactMenu';
import UserMenuLinks from './UserMenuLinks';
import HkBadge from '../../components/@hk-badge/@hk-badge';
import { logException } from '../../services/LoggingService';
import { getUserName, getTenantName, getTenantDisplayname, clearCachedAccessTokenProps, getAvailableTenants } from '../../utils/tokenUtils';
import { performTenantSwitch } from '../../utils/tenantSwitchUtils';

const styles = {
    telescopeGradient: {
      background: 'linear-gradient(90deg, rgba(83,108,48,1) 0%, rgba(45,46,70,1) 25%, rgba(45,46,70,1) 100%)',
    },
    developmentIndicator: {
      background: 'linear-gradient(45deg, #ff4444, #ff6666)',
      color: 'white',
      padding: '4px 8px',
      fontSize: '11px',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      borderRadius: '3px',
      marginRight: '12px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
    }
};

const CompactNav = ({ navCollapsed, toggleCollapsedNav }) => {

    const navigate = useNavigate();
    const [userName, setUserName] = useState(() => getUserName());
    const [tenantName, setTenantName] = useState(() => getTenantName());
    const [availableTenants, setAvailableTenants] = useState(() => getAvailableTenants());
    const [isSwitching, setIsSwitching] = useState(false);

    // Development mode detection
    const isDevelopment = import.meta.env.DEV;

    // MS-Entra / MSAL
    const { instance } = useMsal();
    const { loginRedirect: handleLoginRedirect } = useEntraLoginRedirect();

    const activeTenantName = getTenantName() ? getTenantName() : "unknown tenant";
    const activeTenantDisplayname = getTenantDisplayname() ? getTenantDisplayname() : activeTenantName;

    const handleLogoutRedirect = () => {
        // explicitly CLEAR the cached BADDOG ACCESS_TOKEN  
        localStorage.removeItem('authToken');
        clearCachedAccessTokenProps();

        instance.logoutRedirect().catch((error) => {
            console.log(error)
            logException(error);
        });
    };

    const handleTenantSwitch = async (targetTenantName) => {
        setIsSwitching(true);
        const success = await performTenantSwitch(instance, targetTenantName);
        setIsSwitching(false);
        if (success) {
            window.dispatchEvent(new Event('tenantChanged'));
            navigate('/landing', { replace: true });
        } else {
            console.error('Tenant switch failed for:', targetTenantName);
        }
    };

    useEffect(() => {
      const syncUser = () => setUserName(getUserName());
      const syncTenant = () => {
        setTenantName(getTenantName());
        setAvailableTenants(getAvailableTenants());
      };
      
      window.addEventListener('userNameChanged', syncUser);
      window.addEventListener('userNameChanged', syncTenant);
      window.addEventListener('tenantChanged', syncTenant);
      
      return () => {
        window.removeEventListener('userNameChanged', syncUser);
        window.removeEventListener('userNameChanged', syncTenant);
        window.removeEventListener('tenantChanged', syncTenant);
      };
    }, []);

    return (
        <Navbar expand="xl" className="hk-navbar navbar-dark fixed-top" style={styles.telescopeGradient} >
            <Container fluid>
                {/* Start Nav */}
                <div className="nav-start-wrap flex-fill">
                    {/* Brand */}
                    <Link className="navbar-brand" to="/">
                        <img className="brand-img img-fluid" src={BrandSm} alt="brand" width="175" /> 
                        {/* <img className="brand-img img-fluid" src={jampackImg} alt="brand" width="180" /> */}
                    </Link>
                    {/* <Link to="/" className="navbar-brand d-xl-flex d-none">
                        <img className="brand-img img-fluid" src={BrandSm} alt="brand" />
                        <img className="brand-img img-fluid" src={Brand} alt="brand" />
                    </Link> */}
                    {/* /Brand */}

                    <Button onClick={() => toggleCollapsedNav(!navCollapsed)} className="btn-icon btn-rounded btn-flush-dark flush-soft-hover navbar-toggle d-xl-none">
                        <span className="icon">
                            <span className="feather-icon"><AlignLeft /></span>
                        </span>
                    </Button>
                    {/* <!-- Navbar Nav --> */}
                    <CompactMenu />
                    <div onClick={() => toggleCollapsedNav(!navCollapsed)} className="hk-menu-backdrop" />
                </div>
                {/* End Nav */}
                <div className="nav-end-wrap">
                    {/* Development Mode Indicator */}
                    {isDevelopment && (
                        <div style={styles.developmentIndicator}>
                            ⚠️ DEVELOPMENT MODE ⚠️
                        </div>
                    )}
                    
                    {/* Search */}
                    <NavSearch />

                    <Nav className="navbar-nav flex-row">

                        {/* <Nav.Item>
                            <Button variant="flush-dark" as={Link} to="/apps/email" className="btn-icon btn-rounded flush-soft-hover">
                                <span className="icon">
                                    <span className=" position-relative">
                                        <span className="feather-icon"><Inbox /></span>
                                        <HkBadge bg="primary" soft pill size="sm" className="position-top-end-overflow-1" >4</HkBadge>
                                    </span>
                                </span>
                            </Button>
                        </Nav.Item> */}

                        <Nav.Item>
                            <Dropdown className="dropdown-notifications">
                                {/* <Dropdown.Toggle variant="flush-dark" className="btn-icon btn-rounded flush-soft-hover no-caret">
                                    <span className="icon">
                                        <span className="position-relative">
                                            <span className="feather-icon"><Bell /></span>
                                            <HkBadge bg="success" indicator className="position-top-end-overflow-1" />
                                        </span>
                                    </span>
                                </Dropdown.Toggle> */}
                                <Dropdown.Menu align="end" className="p-0">
                                    <Dropdown.Header className="px-4 fs-6">
                                        Notifications
                                        <Button variant="flush-dark" className="btn-icon btn-rounded flush-soft-hover">
                                            <span className="icon">
                                                <span className="feather-icon"><Settings /></span>
                                            </span>
                                        </Button>
                                    </Dropdown.Header>
                                    <SimpleBar className="dropdown-body  p-2">
                                        <Dropdown.Item>
                                            <div className="media">
                                                <div className="media-head">
                                                    <div className="avatar avatar-rounded avatar-sm">
                                                        <img src={avatar2} alt="user" className="avatar-img" />
                                                    </div>
                                                </div>
                                                <div className="media-body">
                                                    <div>
                                                        <div className="notifications-text">Morgan Freeman accepted your invitation to join the team</div>
                                                        <div className="notifications-info">
                                                            <HkBadge bg="success" soft >Collaboration</HkBadge>
                                                            <div className="notifications-time">Today, 10:14 PM</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Dropdown.Item>
                                        <Dropdown.Item>
                                            <div className="media">
                                                <div className="media-head">
                                                    <div className="avatar  avatar-icon avatar-sm avatar-success avatar-rounded">
                                                        <span className="initial-wrap">
                                                            <span className="feather-icon"><Inbox /> </span>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="media-body">
                                                    <div>
                                                        <div className="notifications-text">New message received from Alan Rickman</div>
                                                        <div className="notifications-info">
                                                            <div className="notifications-time">Today, 7:51 AM</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Dropdown.Item>
                                        <Dropdown.Item>
                                            <div className="media">
                                                <div className="media-head">
                                                    <div className="avatar  avatar-icon avatar-sm avatar-pink avatar-rounded">
                                                        <span className="initial-wrap">
                                                            <span className="feather-icon"><Clock /></span>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="media-body">
                                                    <div>
                                                        <div className="notifications-text">You have a follow up with Jampack Head on Friday, Dec 19 at 9:30 am</div>
                                                        <div className="notifications-info">
                                                            <div className="notifications-time">Yesterday, 9:25 PM</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Dropdown.Item>
                                        <Dropdown.Item>
                                            <div className="media">
                                                <div className="media-head">
                                                    <div className="avatar avatar-sm avatar-rounded">
                                                        <img src={avatar3} alt="user" className="avatar-img" />
                                                    </div>
                                                </div>
                                                <div className="media-body">
                                                    <div>
                                                        <div className="notifications-text">Application of Sarah Williams is waiting for your approval</div>
                                                        <div className="notifications-info">
                                                            <div className="notifications-time">Today 10:14 PM</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Dropdown.Item>
                                        <Dropdown.Item>
                                            <div className="media">
                                                <div className="media-head">
                                                    <div className="avatar avatar-sm avatar-rounded">
                                                        <img src={avatar10} alt="user" className="avatar-img" />
                                                    </div>
                                                </div>
                                                <div className="media-body">
                                                    <div>
                                                        <div className="notifications-text">Winston Churchil shared a document with you</div>
                                                        <div className="notifications-info">
                                                            <HkBadge bg="violet" soft >File Manager</HkBadge>
                                                            <div className="notifications-time">2 Oct, 2021</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Dropdown.Item>
                                        <Dropdown.Item>
                                            <div className="media">
                                                <div className="media-head">
                                                    <div className="avatar  avatar-icon avatar-sm avatar-danger avatar-rounded">
                                                        <span className="initial-wrap">
                                                            <span className="feather-icon"><Calendar /></span>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="media-body">
                                                    <div>
                                                        <div className="notifications-text">Last 2 days left for the project to be completed</div>
                                                        <div className="notifications-info">
                                                            <HkBadge bg="orange" soft >Updates</HkBadge>
                                                            <div className="notifications-time">14 Sep, 2021</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Dropdown.Item>
                                    </SimpleBar>
                                    <div className="dropdown-footer">
                                        <Link to="#"><u>View all notifications</u>
                                        </Link>
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav.Item>
                        <Nav.Item>
                            <Dropdown className="ps-2">
                                <Dropdown.Toggle as="button" className="no-caret btn btn-link p-0 border-0">
                                    <div className="avatar avatar-rounded avatar-xs">
                                        <img src={avatar12} alt="user" className="avatar-img" />
                                    </div>
                                </Dropdown.Toggle>
                                <Dropdown.Menu align="end">
                                    <div className="p-2">
                                        <div className="media">
                                            <div className="media-head me-2">
                                                <div className="avatar avatar-primary avatar-sm avatar-rounded">
                                                    <span className="initial-wrap">3C</span>
                                                </div>
                                            </div>
                                            <div className="media-body">
                                                <Dropdown>
                                                    <Dropdown.Toggle as="button" className="d-block fw-medium text-dark btn btn-link p-0 border-0 text-start">{activeTenantDisplayname}</Dropdown.Toggle>
                                                    
                                                    <Dropdown.Menu align="end">
                                                        <div className="p-2">
                                                            <div className="media align-items-center active-user mb-3">
                                                                <div className="media-head me-2">
                                                                    <div className="avatar avatar-primary avatar-xs avatar-rounded">
                                                                        <span className="initial-wrap">Hk</span>
                                                                    </div>
                                                                </div>
                                                                <div className="media-body">

                                                                    <Link to="#" className="d-flex link-dark">{activeTenantName}<i className="ri-checkbox-circle-fill fs-7 text-primary ms-1" />
                                                                    </Link>
                                                                    <Link to="#" className="d-block fs-8 link-secondary">
                                                                        <u>Manage your account</u>
                                                                    </Link>
                                                                </div>
                                                            </div>

                                                            {/* {availableTenants.length > 1 ? (
                                                                availableTenants
                                                                    .filter(({ tenantname }) => tenantname !== activeTenantName)
                                                                    .map(({ tenantname }) => (
                                                                        <div key={tenantname} className="media align-items-center mb-2">
                                                                            <div className="media-head me-2">
                                                                                <div className="avatar avatar-xs avatar-rounded">
                                                                                    <span className="initial-wrap">
                                                                                        <i className="ri-building-line" />
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="media-body">
                                                                                <button
                                                                                    className="d-block link-dark btn btn-link p-0 border-0 text-start fs-7"
                                                                                    disabled={isSwitching}
                                                                                    onClick={() => handleTenantSwitch(tenantname)}
                                                                                >
                                                                                    {tenantname}
                                                                                    {isSwitching && (
                                                                                        <span className="spinner-border spinner-border-sm ms-1" role="status" aria-hidden="true" />
                                                                                    )}
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                            ) : (
                                                                <Button variant="outline-light" size="sm" className="btn-block">
                                                                    <span>
                                                                        <span className="icon">
                                                                            <span className="feather-icon">
                                                                                <Plus />
                                                                            </span>
                                                                        </span>
                                                                        <span>Add Account</span></span>
                                                                </Button>
                                                            )} */}
                                                            
                                                        </div>
                                                    </Dropdown.Menu>

                                                </Dropdown>


                                                {/* <div className="fs-7">{getUserName() || "EXTERNAL ACCOUNT (Guest)"}</div> */}
                                                <div className="fs-7">{userName || "EXTERNAL ACCOUNT (Guest)"}</div>

                                            </div>

                                        </div>
                                            
                                    </div>

                                    <AuthenticatedTemplate>
                                        <Button variant="link" onClick={handleLogoutRedirect} className="d-block fs-8 link-secondary"><u>Sign Out</u></Button>
                                    </AuthenticatedTemplate>

                                    {/* <AuthenticatedTemplate>
                                        <h5>AUTHENTICATED</h5>
                                    </AuthenticatedTemplate> */}

                                    <UnauthenticatedTemplate>
                                        <div className="collapse navbar-collapse justify-content-end">
                                            <Button onClick={handleLoginRedirect}>XXX Sign in</Button>
                                        </div>
                                    </UnauthenticatedTemplate>


                                    <Dropdown.Divider as="div" />
                                    <Dropdown.Item as={Link} to="/pages/profile" >Profile</Dropdown.Item>

                                    <UserMenuLinks />

                                    {/* <Dropdown.Item>
                                        <span className="me-2">Offers</span>
                                        <span className="badge badge-sm badge-soft-pink">2</span>
                                    </Dropdown.Item> */}

                                    {/* <div className="dropdown-divider" />
                                    <h6 className="dropdown-header">Manage Account</h6>
                                    <Dropdown.Item>
                                        <span className="dropdown-icon feather-icon">
                                            <CreditCard />
                                        </span>
                                        <span>Payment methods</span>
                                    </Dropdown.Item>
                                    <Dropdown.Item>
                                        <span className="dropdown-icon feather-icon">
                                            <CheckSquare />
                                        </span>
                                        <span>Subscriptions</span>
                                    </Dropdown.Item>
                                    <Dropdown.Item>
                                        <span className="dropdown-icon feather-icon">
                                            <Settings />
                                        </span>
                                        <span>Settings</span>
                                    </Dropdown.Item>
                                    <div className="dropdown-divider" />
                                    <Dropdown.Item>
                                        <span className="dropdown-icon feather-icon">
                                            <Tag />
                                        </span>
                                        <span>Raise a ticket</span>
                                    </Dropdown.Item> */}
                                    <div className="dropdown-divider" />
                                    <Dropdown.Item>
                                        Terms &amp; Conditions
                                    </Dropdown.Item>
                                    <Dropdown.Item>
                                        Help &amp; Support
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav.Item>
                    </Nav>
                </div>
                {/* /End Nav */}
            </Container>
        </Navbar>
    )
}

const mapStateToProps = ({ theme }) => {
    const { navCollapsed } = theme;
    return { navCollapsed }
};

export default connect(mapStateToProps, { toggleCollapsedNav })(CompactNav);